import { useNavigate, useSearch } from '@tanstack/react-router';

import type {
  ChangelogFilter,
  ChangelogSortDirection,
  ChangelogSortProperty,
} from '../../changelog/model';
import {
  changelogRouteSearchSchema,
  parseChangelogRouteSearch,
  serializeChangelogRouteSearch,
} from './changelogRouteSearch';

export function useChangelogRouteFilters() {
  const navigate = useNavigate({ from: '/admin/changelog' });
  const search = useSearch({ strict: false });
  const filter = parseChangelogRouteSearch(changelogRouteSearchSchema(search));
  const update = (next: ChangelogFilter) => {
    void navigate({ search: serializeChangelogRouteSearch(next), replace: true });
  };
  return {
    filter,
    setFilters: (updates: Partial<ChangelogFilter>) => {
      update({ ...filter, ...updates, page: 0 });
    },
    resetFilters: () => {
      update(parseChangelogRouteSearch({}));
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
    setSort: (
      sortProperty: ChangelogSortProperty | null,
      sortDirection: ChangelogSortDirection,
    ) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
  };
}
